/* @flow */
import * as React from 'react';
import styles from './styles.module.scss';
import { withTranslation } from 'react-i18next';
import Checkbox from 'components/Checkbox';

import type { Translate } from 'types';

type headerField =
  | 'cover'
  | 'name'
  | 'channelName'
  | 'area'
  | 'production'
  | 'episode'
  | 'itemsCount'
  | 'createDate'
  | 'modifiedDate';

type Props = {
  showCheckbox?: boolean,
  isSelectable?: boolean,
  isSelected?: boolean,
  onHeaderClick?: (field: headerField) => mixed,
  onCheckboxClick?: () => mixed,
  t: Translate,
};

class WorklistHeader extends React.PureComponent<Props, void> {
  render() {
    const {
      showCheckbox,
      isSelectable,
      isSelected,
      onHeaderClick,
      onCheckboxClick,
      t,
    } = this.props;
    return (
      <div className={styles.container}>
        {isSelectable && (
          <div className={styles.checkbox}>
            {showCheckbox ? (
              <Checkbox onClick={onCheckboxClick} small={true} checked={isSelected} />
            ) : null}
          </div>
        )}
        <div
          className={styles.cover}
          onClick={() => (onHeaderClick ? onHeaderClick('cover') : undefined)}
        >
          <div>{'A'}</div>
        </div>
        <div
          className={styles.name}
          onClick={() => (onHeaderClick ? onHeaderClick('name') : undefined)}
        >
          <div>{t('NAME')}</div>
        </div>
        <div
          className={styles.channelName}
          onClick={() => (onHeaderClick ? onHeaderClick('channelName') : undefined)}
        >
          <div>{t('CHANNEL')}</div>
        </div>
        <div
          className={styles.area}
          onClick={() => (onHeaderClick ? onHeaderClick('area') : undefined)}
        >
          <div>{t('AREA')}</div>
        </div>
        <div
          className={styles.production}
          onClick={() => (onHeaderClick ? onHeaderClick('production') : undefined)}
        >
          <div>{t('PRODUCTION')}</div>
        </div>
        <div
          className={styles.episode}
          onClick={() => (onHeaderClick ? onHeaderClick('episode') : undefined)}
        >
          <div>{t('EPISODE')}</div>
        </div>
        <div
          className={styles.number}
          onClick={() => (onHeaderClick ? onHeaderClick('itemsCount') : undefined)}
        >
          <div>{t('ELEMENTS')}</div>
        </div>
        <div
          className={styles.createDate}
          onClick={() => (onHeaderClick ? onHeaderClick('createDate') : undefined)}
        >
          <div className={styles.sortable}>{t('CREATE_DATE')}</div>
        </div>
        <div
          className={styles.modifiedDate}
          onClick={() => (onHeaderClick ? onHeaderClick('modifiedDate') : undefined)}
        >
          <div className={styles.sortable}>{t('MODIFIED_DATE')}</div>
        </div>
        <div className={styles.actions}>
          <div className={styles.sortable} />
        </div>
      </div>
    );
  }
}

export default withTranslation()(WorklistHeader);
